import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import GlobalFilterPanel, {FILTER_PERIOD_GROUP} from '../filter/GlobalFilterPanel';
import {AnalysisType, AnalysisTypeMainVATCodeOnly} from '../../utils/enums';
import { SSelect } from "@avalara/skylab-sdk/react";

const FORM_NAME = 'ANALYSIS_FILTER_PANEL';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const ANALYSIS_OPTIONS = [
    AnalysisType.VAT_CODE,
    AnalysisType.VAT_CODE_GENERIC
];

class AnalysisFilterPanel extends React.Component {

    constructor(props) {
        super(props); 
        this.state = {
            selection: {
                groupBy: AnalysisType.VAT_CODE,
                mainVATCodesOnly: false
            }
        };
        this.inputChangeHandlerFactory = this.inputChangeHandlerFactory.bind(this);
        this.checkboxChangeHandlerFactory = this.checkboxChangeHandlerFactory.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
        this.getAnalysisType = this.getAnalysisType.bind(this);
        this.onGroupByChange = this.onGroupByChange.bind(this);
    }

    onGroupByChange(event) {
        if (event?.detail?.item?.value) {
            let selection = Object.assign({}, this.state.selection);
            selection.groupBy = this.getAnalysisType(event.detail.item.value, this.state.selection.mainVATCodesOnly);
            this.setState({ selection: selection });
        }
    }

    onSearchClickHandler(globalSelection) {
        log.debug('onSearchClickHandler() - globalSelection: ', globalSelection);
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);        
        let combinedSelection = Object.assign({}, this.state.selection, globalSelection);
        log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
        this.props.onSearchClick(combinedSelection);
    }

    getAnalysisType(nameOfEnum, mainVATCodesOnly) {
        let analysisEnumType = AnalysisType;
        if(mainVATCodesOnly) {
            analysisEnumType = AnalysisTypeMainVATCodeOnly;
        }
        return _.isEmpty(nameOfEnum) ? undefined : analysisEnumType.enumValueOf(nameOfEnum);
    }

    inputChangeHandlerFactory(fieldName) {
        return (event) => {
          log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
          log.clearSuccessMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
          log.clearAllDictionaryErrors();
          log.debug('inputChangeHandlerFactory(%s): %s, ', fieldName, event);
          log.debug('inputChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.state.selection[fieldName], event.detail.item.value, event.detail.item.value);
          let selection = Object.assign({}, this.state.selection);          
          selection[fieldName] = this.getAnalysisType(event.detail.item.value, this.state.selection.mainVATCodesOnly);
          this.setState({
              selection: selection
          });
        };
    }

    globalFilterPanelChangeHandler() {
        log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
        log.clearSuccessMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
        log.clearAllDictionaryErrors();
    }

    checkboxChangeHandlerFactory(fieldName) {
        return (event) => {
          log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
          log.clearSuccessMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
          log.clearAllDictionaryErrors();
          log.debug('checkboxChangeHandlerFactory(%s): %s, ', fieldName, event);
          log.debug('checkboxChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.state.selection[fieldName], event.target.checked);
          let selection = Object.assign({}, this.state.selection);
          selection[fieldName] = event.target.checked;
          //Also need to update group by
          selection.groupBy = this.getAnalysisType(this.state.selection.groupBy && this.state.selection.groupBy.name, event.target.checked);
          this.setState({
              selection: selection
          });
        };
    }

   
    render() {
        log.debug('render(): ', this.props);               
        const {selection={}} = this.state;
        const globalFilterPanelOptions = {
            onFieldChange: this.globalFilterPanelChangeHandler,
            countries: this.props.countryList,
            filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,             
            hideElements: {
              'month': true,
              'year':true,
              returnType: true,
              returnStatus: true
            },
            onSearchClick: this.onSearchClickHandler
        };
        return (
            <s-box name="filter-panel">
                <GlobalFilterPanel {...globalFilterPanelOptions}>
                    <fieldset>
                        <label>{LANGUAGE_CONTROLLER.format(this.props.languages, 'analysisFilter_GroupBy')}</label>
                        <SSelect
                            inputId="single-groupby-select"
                            name="groupby"
                            onS-select={this.onGroupByChange}
                            optionsList={ANALYSIS_OPTIONS.map((analysisType) => ({
                                label: LANGUAGE_CONTROLLER.format(this.props.languages, analysisType.languageString),
                                value: analysisType.name,
                                selected: (selection.groupBy?.name) === analysisType.name
                            })) || []}
                            multiple={false}
                            showSelectionCount={false}
                        />
                    </fieldset>
                    <fieldset>
                        <legend>{LANGUAGE_CONTROLLER.format(this.props.languages, 'analysisFilter_mainVATCodesOnly')}</legend>
                        <span className="clear"></span>
                        <input 
                            type="checkBox"                                    
                            name="mainVATCodeOnly"
                            checked={selection.mainVATCodesOnly}
                            onChange={this.checkboxChangeHandlerFactory('mainVATCodesOnly')}
                        />
                        <label className="checkbox">True</label>
                    </fieldset>
                </GlobalFilterPanel>
                <div className="clear"></div>                    
            </s-box>
        );
    }

    componentDidMount() {                
        let filterOptions = this.props.filterOptions;
        log.debug('componentDidMount() - filterOptions: ', this.props.filterOptions);        
        if(filterOptions) {
            let selection = {};
            selection.mainVATCodesOnly = filterOptions.mainVATCodesOnly+'' === 'true';
            // Check if filterOptions.groupBy is a valid enum (has name and value properties)
            if(filterOptions.groupBy && filterOptions.groupBy.name && filterOptions.groupBy.value !== undefined) {
                selection.groupBy = filterOptions.groupBy;
            } else {
                selection.groupBy = selection.mainVATCodesOnly ? AnalysisTypeMainVATCodeOnly.VAT_CODE_GENERIC : AnalysisType.VAT_CODE;
            }
            this.setState({
                selection: selection
            });
        }
    }
}


AnalysisFilterPanel.defaultProps = {
    onSearchClick: () => {},
    countryList: []
};

function mapStateToProps(state) {
    return {
      languages: state.languages,
    };
  }

export default  connect(mapStateToProps)(AnalysisFilterPanel);
